import { Inquiry, InquiryRow } from "./types";

export const transformInquiryRow = (res: any): InquiryRow => ({
  id: res.id,
  inquirySourceId: res.inquirySourceId,
  inquirySourceName: res.inquirySourceName,
  customerName: res.customerName,
  customerEmail: res.customerEmail,
  customerPhone: res.customerPhone,
  status: res.status,
  vehicleListingId: res.vehicleListingId,
  created: res.created,
  assignedUserName: res.assignedUserName,
});

export const transformInquiry = (res: any): Inquiry => ({
  id: res.id,
  inquirySourceId: res.inquirySourceId,
  inquirySourceName: res.inquirySourceName,
  vehicleListingId: res.vehicleListingId,
  fleetVehicleId: res.fleetVehicleId,
  contactId: res.contactId,
  externalInquiryId: res.externalInquiryId,
  customerName: res.customerName,
  customerEmail: res.customerEmail,
  customerPhone: res.customerPhone,
  message: res.message,
  status: res.status,
  assignedUserId: res.assignedUserId,
  assignedUserName: res.assignedUserName,
  notes: res.notes,
  created: res.created,
});
